import script from "./KUploaderCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./KUploaderCarousel.vue?vue&type=script&setup=true&lang=ts"

import "./KUploaderCarousel.vue?vue&type=style&index=0&id=1832fab4&scoped=true&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1832fab4"]])

export default __exports__
import QResizeObserver from 'quasar/src/components/resize-observer/QResizeObserver.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QResizeObserver,QImg});
